import { showEmptyCartModal } from "../helper/showEmptyCartModal";

export function showHashMismatchModal(cartSize) {
    if (cartSize === 0) {
        showEmptyCartModal();
    } else {
        setTimeout(function () {
            document.getElementById('hash-mismatch-modal-trigger').click();
        }, 100);
    }
}
